module.exports = __webpack_public_path__ + "img/ePhoto_Code.4536cb13.png";